module.exports = __webpack_public_path__ + "media/images/logo-black-bg-66b424beb235bce703effe21d2d686cd.png";